import { Box, Button } from "@mui/material";
import { FC, useRef, useState } from "react";
import CustomButton from "../../../components/_common/CustomButton";
import CustomDialog from "../../../components/_common/CustomDialog";
import LoadingAnimation from "../../../components/_common/Loading";
import { CartItem, useCart } from "../../../hooks/useCart";
import furnitureController from "../../../Api/furnitureController";
import { useToast } from "../../../hooks/useToast";

interface AdminToolsProps {
    cartItems: CartItem[],
}

const AdminTools: FC<AdminToolsProps> = ({
    cartItems,
}) => {

    const [showAdminTools, setShowAdminTools] = useState(false);
    const [showDeleteAlert, setShowDeleteAlert] = useState(false);
    const [loading, setLoading] = useState(false);
    const toast = useRef(useToast()).current
    const cart = useCart()

       const handleDelete = async () => {
        setLoading(true);
    
        try {
            const results = await Promise.all(
                cartItems.map(async (item) => {
                    const res = await furnitureController.deleteFurniture(item.id);
                    if (res.ok) {
                        cart.remove(item.id); 
                        toast.success(`Usunięto mebel: ${item.name}`);
                    } else {
                        toast.error(`Nie udało się usunąć mebla: ${item.name}`);
                    }
                    return res;
                })
            );
            
            const allSuccessful = results.every((res) => res.ok);
            if (allSuccessful) {
                toast.success("Wszystkie meble zostały usunięte z bazy danych i koszyka.");
            } else {
                toast.error("Niektóre meble nie zostały usunięte.");
            }
        } catch (error) {
            toast.error("Wystąpił błąd podczas usuwania mebli.");
        }
    
        setLoading(false);
    };

    if (loading) return (
        <LoadingAnimation />
    )

    return (
        <>
            <Box sx={{ mb: 2 }}>
                <CustomButton
                    text={showAdminTools ? "Ukryj narzędzia administracyjne" : "Pokaż narzędzia administracyjne"}
                    onClick={() => setShowAdminTools(!showAdminTools)}
                />
                {showAdminTools &&
                    <Button
                        color="error"
                        variant="contained"
                        sx={{ mt: 1, width: '100%' }}
                        onClick={() => setShowDeleteAlert(true)}
                    >
                        Usuń meble z bazy danych
                    </Button>
                }
                {showAdminTools &&
                    <Button
                        color="success"
                        variant="contained"
                        sx={{ mt: 1, width: '100%' }}
                        onClick={() => cart.clearCart()}
                    >
                        Wyczyść koszyk
                    </Button>
                }
                <CustomDialog
                    sx={{ backgroundColor: 'red' }}
                    open={showDeleteAlert}
                    onSetOpen={setShowDeleteAlert}
                    title="UWAGA"
                    description="Usuwasz nieodwracalnie meble z bazy danych, szkody jakie mogą powstać w wyniku nieprawidłowego usunięcia mebli będą ogromne. Upewnij się 10 razy że w koszyku są tylko te meble które chcesz usunąć. Czy na pewno chcesz usunąć meble z bazy?"
                    onAgree={() => handleDelete()}
                />
            </Box>
        </>
    )
}

export default AdminTools;